import LayoutPage from "../../../templates/Layout/LayoutPage";
import Container from '@mui/material/Container';

function AccessDenied() {

  const errorStyles = {
    textAlign: 'center',
    '& h2': {
      fontSize: {
        xs: '4rem',
        lg: '5rem'
      },
      marginBottom: 0,
    },
    '& p': {
      fontSize: '1.5rem',
      marginTop: 0,
    }
  }

  return (
    <LayoutPage
      pageTitle="Access Denied"
      description="Deny Access to request data."
      type="basic">
      <Container maxWidth="md" sx={errorStyles}>
        <h2>Access Denied</h2>
        <p>You are not allowed to access this page</p>
      </Container>
    </LayoutPage>
  );
}

export default AccessDenied;
